import React, { useState, useEffect } from "react";
import _ from "lodash";
import { motion } from "framer-motion/dist/framer-motion";

import { bounce_right_to_left_variants } from "shared/components/animations";

const VBOver = ({ teams, users }) => {
  const [result, setResult] = useState({ unit: "", text: "" });
  const [usersArray, setUsersArray] = useState([]);

  const getUsers = (team) => {
    let array = [];
    array = team.team_queue.map((item) =>
      users.find((user) => user.player_id === item)
    );
    array = [
      ...array,
      users.find((user) => user.player_id === team.quarterback)
    ];
    setUsersArray([...array]);
  };

  useEffect(() => {
    if (teams.length > 0) {
      if (teams[0].score === teams[1].score) {
        setResult({ unit: "tie", text: "TIE GAME!" });
        setUsersArray(users);
      } else if (teams[0].score > teams[1].score) {
        setResult({ unit: "teamA", text: "TEAM ALPHA WINS!" });
        getUsers(teams[0]);
      } else if (teams[0].score < teams[1].score) {
        setResult({ unit: "teamB", text: "TEAM BETA WINS!" });
        getUsers(teams[1]);
      }
    }
  }, [teams, users]);

  return (
    <div className="vb-over">
      <motion.div
        variants={bounce_right_to_left_variants}
        initial="hidden"
        animate="visible"
        exit="exit"
        className={`vb-card-div over ${result.unit}`}
      >
        <h2 className="over-text">GOOD GAME!</h2>
        <h2 className={`over-team-text ${result.unit}`}>{result.text}</h2>
        <div className="vb-over-list">
          {!_.isEmpty(usersArray) &&
            usersArray.map((user, index) => (
              <div key={index} className="player-div">
                <div className="player-inner-div">
                  <img
                    alt=""
                    src={user.profile_image}
                    className={`avatar ${result.unit}`}
                  />
                  <h2>{user.display_name}</h2>
                </div>
              </div>
            ))}
        </div>
      </motion.div>
    </div>
  );
};

export default VBOver;
